// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3q6yK","upload":"Small_upload__oi1BL","imageWrap":"Small_imageWrap__FO_vk","removeBtn":"Small_removeBtn__2hHim"};